import { COLORS } from '@mafc/common';
import { Box, Text, customStyled } from '@mafc/trolly';

export const AvailablePromotions = customStyled(Box)(({ theme }) => ({
  backgroundColor: COLORS.HIGHLIGHT_COLOR,
  borderRadius: theme.radii[3],
}));

export const DueAmount = customStyled(Box)(({ theme }) => ({
  color: theme.colors.black,
  padding: '0 16px 12px',
}));

export const Savings = customStyled(Text.Caption)(({ theme }) => ({
  color: theme.colors.black,
  fontWeight: theme.fontWeights[7],
  fontSize: theme.fontSizes[2],
}));
